<template>
  <div class="container">
    <template>
      <h4 class="not-margin"
          :style="{ fontWeight: 'bold', color: 'crimson', fontSize: '18px', textAlign: 'left' }">
        <i class="fad fa-trash-alt" :style="{ width: '25px', fontSize: '18px' }"></i>
        ລຶບລົດຂົນສົ່ງ
      </h4>
    </template>
    <div class="field" :style="{marginTop: '20px'}">
      <p>
        ທ່ານຕ້ອງການລຶບລົດຄັນນີ້ ແທ້ ຫຼື ບໍ່?
        <br>
        <span :style="{color: 'grey', fontSize: '13px'}">
          (ຖ້າລົດມີຖ້ຽວແລ່ນຢູ່ ລະບົບຈະບໍ່ອະນຸຍາດໃຫ້ລຶບ — ແນະນຳໃຫ້ປິດການໃຊ້ງານແທນ)
        </span>
      </p>
    </div>
    <div ref="target" id="target" class="center">
      <div class="con-btns">
        <vs-button ref="button" flat danger class="form-btn-loading" :loading="btnLoading"
                   @click="DeleteTruck(truckId)">
          ຢືນຢັນການລຶບ
        </vs-button>
      </div>
    </div>
  </div>
</template>

<script>
import MixinFleetTrucks from '@/Mixins/Fleet/Trucks';

export default {
  props: ['truckId'],
  mixins: [MixinFleetTrucks],
};
</script>

<style scoped>
</style>
